export default {
  "columns": [
      "name",
      "code",
      "charge", 
      "code",
  ],
  "headersCellStyle": [
      {
      "position": "-webkit-sticky", /* for Safari */
      "position": "sticky",
      "z-index": "10",
      "top": "0px",
      "background": "#4d82cb",
      "border-bottom": "1px solid black",
      "color": "#FFF",
      "width": "20px"
      }
    ],
  "columnsStyles": [
    {
      "text-align": "center",
      "width": "150px"
    },
    {
      "text-align": "center",
      "width": "100px",
    },
    {
      "text-align": "center",
      "width": "100px"
    },
    {
      "text-align": "center",
      "width": "100px"
    },
    {
      "text-align": "center",
      "width": "100px"
    }
  ],
  "headers": [
      {
          "colspan": "1",
          "name": "#",
          "rowspan": "2"
      },
      {
          "colspan": "1",
          "name": "name",
          "rowspan": "2"
      },
      {
          "colspan": "1",
          "name": "code",
          "rowspan": "2"
      },
      {
          "colspan": "2",
          "name": "charge",
          "rowspan": "1"
      }
  ],
    "rows": [
        {
            "charge": "10 638 509 409",
            "code": 1000,
            "id": 0,
            "name": "Еврейская автономная область",
            "sub_rows": []
        },
        {
            "charge": 20712782142,
            "code": 1010,
            "id": 1,
            "name": "Налоговые и неналоговые доходы",
            "sub_rows": []
        },
        {
            "charge": 20521675770,
            "code": 1020,
            "id": 2,
            "name": "Налоговые доходы",
            "sub_rows": []
        },
        {
            "charge": 1511497837,
            "code": 1220,
            "id": 26,
            "name": "Акцизы по подакцизным товарам (продукции), производимым на территории Российской Федерации",
            "sub_rows": []
        },
        {
            "charge": 187767632,
            "code": 1428,
            "id": 52,
            "name": "Налоги на товары, ввозимые на территорию Российской Федерации",
            "sub_rows": []
        },
        {
            "charge": 0,
            "code": 1840,
            "id": 127,
            "name": "Государственная пошлина",
            "sub_rows": []
        },
        {
            "charge": "NaN",
            "code": "NaN",
            "id": 128,
            "name": "из нее",
            "sub_rows": []
        },
        {
            "charge": 114606,
            "code": 1970,
            "id": 142,
            "name": "Задолженность и перерасчеты по отмененным налогам, сборам и иным обязательным платежам",
            "sub_rows": []
        },
        {
            "charge": 191106372,
            "code": 2370,
            "id": 219,
            "name": "Неналоговые доходы, администрируемые налоговыми органами",
            "sub_rows": []
        },
        {
            "charge": 0,
            "code": 2375,
            "id": 220,
            "name": "Доходы от использования имущества, находящегося в государственной и муниципальной собственности",
            "sub_rows": []
        },
        {
            "charge": 1950933,
            "code": 2380,
            "id": 224,
            "name": "Платежи при пользовании природными ресурсами",
            "sub_rows": []
        },
        {
            "charge": 0,
            "code": 2410,
            "id": 228,
            "name": "Доходы от оказания платных услуг (работ) и компенсации затрат государства",
            "sub_rows": []
        },
        {
            "charge": 0,
            "code": 2440,
            "id": 234,
            "name": "Доходы от продажи материальных и нематериальных активов, административные сборы",
            "sub_rows": []
        },
        {
            "charge": 9713821,
            "code": 2470,
            "id": 237,
            "name": "Штрафы, санкции, возмещение ущерба",
            "sub_rows": []
        }
    ],
    "subheaders": ['fhhhhhh', 'df']
}